import React from 'react';
import { classNames } from '../../../Services/helpers';

const Carousel = ({children, className}) => {

    return <div className={classNames('relative w-full flex gap-3 divide-x snap-x overflow-x-scroll', className)}>
        {children}
    </div>
}

const Item = ({children, className}) => {
    return <div className={classNames('bg-white px-4 first:pl-0 last:pr-0 snap-center shrink-0 grow-0 w-[80%] md:w-[48%]', className)}>
        {children}
    </div>
}

export default Carousel;

export { Item };
